import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Header, Menu } from 'semantic-ui-react';
import AppBar from '../Common/AppBar/AppBar';
import '../Common/Layout.css';
import Workspace from '../Common/Workspace';
import { StitchMembersProvider } from '../StitchMembers';
import FormMember from './FormMember/FormMember';

export default function Enrollment() {
  const { viewDefault } = useParams();
  const [view, setView] = useState(viewDefault || 'member');
  const history = useHistory();

  const handleViewChange = (newView) => {
    setView(newView);
    history.push('/enrollment/' + newView);
  };

  return (
    <StitchMembersProvider>
      <div className="app-layout">
        <AppBar />
        <Workspace />
        <div className="channels box">
          <Header
            as="h4"
            style={{ paddingLeft: '1em', color: '#fff' }}
          >
            Enrollment
          </Header>
          <Menu
            vertical
            secondary
            inverted
            style={{ background: 'transparent' }}
          >
            <Menu.Item
              active={view === 'member'}
              onClick={() => handleViewChange('member')}
            >
              #&nbsp;&nbsp;enroll-member
            </Menu.Item>
          </Menu>
        </div>
        <div className="header-panel box">
          {view === 'member' && (
            <Header as="h4">
              Enroll a Member
              <Header.Subheader>
                Please fill out the form to enroll a member to our RPM
                program.
              </Header.Subheader>
            </Header>
          )}
        </div>

        <div className="messages">
          {view === 'member' && (
            <FormMember />
          )}
        </div>
      </div>
    </StitchMembersProvider>
  );
}
